import theme from '@dbk/ui-theme';

export const DBK16_FONT_FAMILY = {
  DB_DISPLAY : theme.fontFamilyMedium,  // 'DeutscheBank-Medium',
  DB_REGULAR: theme.fontFamilyRegular, 
}